export default __webpack_public_path__ + "static/flag-pt-b6322173e4e7c42726bcb0b67dad9862.svg";